const WPReducer = (state = {}, action) => {
    switch (action.type) {
        case "WPLIST_DOCS":
            return Object.assign({}, state, {
                WP_ListView: action.data
            });
        case "LOOKUP_WPDESC":
            return Object.assign({}, state, {
                WPDESC_LOOKUP: action.data
            });
        case "WPEDIT_DOCS":
            return Object.assign({}, state, {
                geteditwp: action.data
            });
        case "SHARE_WPFILES":
            return Object.assign({}, state, {
                sharedwpfile: action.data
            });
        case "SHARE_WPDATAS":
            return Object.assign({}, state, {
                sharedwpdata: action.data
            });
        case "ERROR_WPFILES":
            return Object.assign({}, state, {
                errorwppass: action.data
            });
        default:
            return state;
    }
};

export default WPReducer;